import ApiService from '@/services/api.service';

const NotificationsService = {
    getAll(parameter) {
        const requestData = {
            method: 'get',
            url: '/MailOptionSetups/',
            params: {
                SearchCriteria: parameter.SearchCriteria,
                PageSize: parameter.PageSize,
                PageNumber: parameter.PageNumber
            }
        };
        return ApiService.customRequest(requestData);
    },
    Add(data) {
        return ApiService.post(`/MailOptionSetups`, data);
    },
    Update(Id, data) {
        return ApiService.put(`/MailOptionSetups/${Id}`, data);
    },
    Delete(Id) {
        return ApiService.delete(`/MailOptionSetups/${Id}`);
    },
    Get(Id) {
        return ApiService.get(`/MailOptionSetups/${Id}`);
    },
    existNotificationType(notificationType) {
        return ApiService.get(`/MailOptionSetups/ExistType/${notificationType}`);
    },
};

export default NotificationsService;
